<template>
  <span
    :class="{'region-button': true, 'region-button__open': active}"
    v-on="$listeners"
    >
      <span
        :class="['region-button_country', 'region-button_country__' + currentCountry.toLowerCase()]"
        v-text="countryText"
      />
  </span>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { AVAILABLE_COUNTRIES } from '@/constants'

@Component
class RegionSelectButton extends Vue {
  @Prop({ type: Boolean, default: false }) active
  @State('country') currentCountry

  get countryText () {
    return this.$t(AVAILABLE_COUNTRIES[this.currentCountry][1])
  }
}

export default RegionSelectButton
</script>

<style lang="scss">
$images_path: "../../common/assets/images";
$countries: ru by kz;

.region-button {
  border: 1px solid #919191;
  border-radius: 20px;
  color: $font-color;
  cursor: pointer;
  padding: 9px 36px 10px;
  transition: background-color .2s,
              color .2s;
  user-select: none;

  @include media_tablet {
    border-radius: 29px;
    padding: 7px 20px 6px 20px;
  }
  @include media_desktop {
    margin-top: 0;
    margin-left: 13px;
    padding: 5px 20px 5px 20px;
  }

  &:hover {
    background-color: #fff;
    color: #333;
  }
  &:active {
    background-color: #999;
    color: #181919;
  }
  &__open {
    @include media_tablet {
      background-color: #fff;
      color: #1a1a1b;
    }
  }
  &_country {
    font-size: 14px;
    padding: 0 11px 0 19px;
    position: relative;
    @include media_tablet {
      padding: 0 16px 0 27px;
    }
    @include media_desktop {
      font-size: 16px;
    }

    &:before {
      background-repeat: no-repeat;
      background-size: 13px 8px;
      content: "";
      height: 8px;
      width: 13px;
      left: 0;
      position: absolute;
      top: 5px;
      @include media_tablet {
        background-size: 17px 11px;
        height: 11px;
        width: 17px;
        top: 2px;
      }
      @include media_desktop {
        top: 4px;
      }
    }
    &:after {
      border-left: 3px solid transparent;
      border-right: 3px solid transparent;
      border-top: 6px solid;
      content: "";
      opacity: .7;
      position: absolute;
      position: absolute;
      right: 0;
      top: 6px;
      transition: transform .15s,
                  opacity .2s,
                  color .2s;
      transform: rotate(0deg);
      @include media_tablet {
        border-left-width: 4px;
        border-right-width: 4px;
        border-top-width: 8px;
        top: 5px;
      }
      @include media_desktop {
        top: 7px;
      }

      .region-button:hover & {
        color: #181919;
      }
      .region-button:active & {
        color: #333;
      }
      .region-button__open & {
        color: #181919;
        transform: rotate(180deg);
      }
    }
    @each $country in $countries {
      &__#{$country}:before {
        background-image: url("./images/flag_#{$country}.png");
      }
    }
  }
}
</style>
